import { OVERLAY_STATUS } from '../constants';

const defaultState = {
    status: false,
};

export const overlay = (state = defaultState, action) => {
    switch (action.type) {
        case OVERLAY_STATUS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
